module.exports = __webpack_public_path__ + "img/2_A.f704edbc.png";